/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { get } from 'lodash';

import PageHeader from '../../components/PageHeader';
import TitleBanner from '../../components/TitleBanner';
import algoliaApi from '../../services/algolia-api';

const SearchResults = ({ query, searchQuery, allowedPages }) => {
  const [searchResults, setSearchResults] = useState([]);

  const fetchSearchResults = async q => {
    if (q) {
      const results = await algoliaApi.getSearchPageResults(q, allowedPages);
      setSearchResults(results);
    }
  };

  const renderItem = obj => {
    return (
      <Link className="cvmi-search-results__item" to={obj.link} key={obj.link}>
        <div>{obj.title}</div>
      </Link>
    );
  };

  const formatSearchQuery = () =>
    searchQuery ? searchQuery.split('?query=')[1] : null;

  useEffect(() => {
    const formattedSearchQuery = formatSearchQuery();
    fetchSearchResults(query || formattedSearchQuery);
  }, [query, searchQuery]);

  useEffect(() => {
    document.title = 'Search Results | CVM Insights';
  }, []);
  return (
    <div>
      <TitleBanner>
        <PageHeader title={`Search: ${query || formatSearchQuery()}`} />
      </TitleBanner>
      <div>
        <div className="cvmi-search-results__content-type-header">
          <i className="fa fa-tv" />
          SHOWS
        </div>
        {get(searchResults, [0, 'options', 'length'], 0) > 0 ? (
          searchResults[0].options.map(renderItem)
        ) : (
          <div className="cvmi-search-results__no-results">No Results</div>
        )}
      </div>
      <div>
        <div className="cvmi-search-results__content-type-header">
          <i className="fa fa-film" /> MOVIES
        </div>
        {get(searchResults, [1, 'options', 'length'], 0) > 0 ? (
          searchResults[1].options.map(renderItem)
        ) : (
          <div className="cvmi-search-results__no-results">No Results</div>
        )}
      </div>
      <div>
        <div className="cvmi-search-results__content-type-header">
          <i className="fa fa-video-camera" /> NETWORKS
        </div>
        {get(searchResults, [2, 'options', 'length'], 0) > 0 ? (
          searchResults[2].options.map(renderItem)
        ) : (
          <div className="cvmi-search-results__no-results">No Results</div>
        )}
      </div>
      <div>
        <div className="cvmi-search-results__content-type-header">
          <i className="fa fa-user" /> ACTORS
        </div>
        {get(searchResults, [3, 'options', 'length'], 0) > 0 ? (
          searchResults[3].options.map(renderItem)
        ) : (
          <div className="cvmi-search-results__no-results">No Results</div>
        )}
      </div>
    </div>
  );
};
export default SearchResults;
